<template>
   <div id="app">
      <textarea v-html="msg" title="no" style="height:150px;width:500px;" ref="msg"></textarea>
      <div v-for="(info, index) in infos" :key="index">
         <TUWEN001 :info="info" v-if="info.template_code == 'T001'" />
         <TUWEN002 :info="info" v-else-if="info.template_code == 'T002'" />
         <TUWEN003 :info="info" v-else-if="info.template_code == 'T003'" />
         <TUWEN004 :info="info" v-else-if="info.template_code == 'T004'" />
         <TUWEN005 :info="info" v-else-if="info.template_code == 'T005'" />
         <TUWEN006 :info="info" v-else-if="info.template_code == 'T006'" />
         <TUWEN007 :info="info" v-else-if="info.template_code == 'T007'" />
         <TUWEN008 :info="info" v-else-if="info.template_code == 'T008'" />
         <TUWEN009 :info="info" v-else-if="info.template_code == 'T009'" />
         <TUWEN010 :info="info" v-else-if="info.template_code == 'T010'" />
         <TUWEN011 :info="info" v-else-if="info.template_code == 'T011'" />
         <TUWEN012 :info="info" v-else-if="info.template_code == 'T012'" />
         <TUWEN013 :info="info" v-else-if="info.template_code == 'T013'" />
         <TUWEN014 :info="info" v-else-if="info.template_code == 'T014'" />
         <TUWEN015 :info="info" v-else-if="info.template_code == 'T015'" />
         <TUWEN016 :info="info" v-else-if="info.template_code == 'T016'" />
         <TUWEN017 :info="info" v-else-if="info.template_code == 'T017'" />
         <TUWEN018 :info="info" v-else-if="info.template_code == 'T018'" />
         <TUWEN019 :info="info" v-else-if="info.template_code == 'T019'" />
         <TUWEN020 :info="info" v-else-if="info.template_code == 'T020'" />
      </div>
   </div>
</template>
<script>
import html2canvas from '@/assets/js/html2canvas.min.js';
import axios from "axios";
import { infos } from './assets/js/example';
import imagesLoaded from 'vue-images-loaded'

import TUWEN001 from './components/TUWEN001.vue';
import TUWEN002 from './components/TUWEN002.vue';
import TUWEN003 from './components/TUWEN003.vue';
import TUWEN004 from './components/TUWEN004.vue';
import TUWEN005 from './components/TUWEN005.vue';
import TUWEN006 from './components/TUWEN006.vue';
import TUWEN007 from './components/TUWEN007.vue';
import TUWEN008 from './components/TUWEN008.vue';
import TUWEN009 from './components/TUWEN009.vue';
import TUWEN010 from './components/TUWEN010.vue';
import TUWEN011 from './components/TUWEN011.vue';
import TUWEN012 from './components/TUWEN012.vue';
import TUWEN013 from './components/TUWEN013.vue';
import TUWEN014 from './components/TUWEN014.vue';
import TUWEN015 from './components/TUWEN015.vue';
import TUWEN016 from './components/TUWEN016.vue';
import TUWEN017 from './components/TUWEN017.vue';
import TUWEN018 from './components/TUWEN018.vue';
import TUWEN019 from './components/TUWEN019.vue';
import TUWEN020 from './components/TUWEN020.vue';

export default {
   name: 'App',
   directives: {
      imagesLoaded
   },
   components: {
      TUWEN001, TUWEN002, TUWEN003, TUWEN004, TUWEN005, TUWEN006, TUWEN007, TUWEN008, TUWEN009, TUWEN010, TUWEN011, TUWEN012, TUWEN013, TUWEN014, TUWEN015, TUWEN016, TUWEN017
      , TUWEN018, TUWEN019, TUWEN020
   },
   data() {
      return {
         task: null,
         length: 0,
         infos: [],
         blobs: [],
         msg: new Date().toLocaleString() + '\r\n',
         error: null,
         is_dev: false,
         template_dev: 'T010',
         index_dev: 0
      }
   },
   async created() {
      await this.Gettask();
      setTimeout(async () => {
         await this.PostError('超时');
      }, 1000 * 60 * 15);
   },
   watch: {
      async blobs() {
         //上传图片
         let file_urls = [];
         if (this.is_dev) {
            return;
         }

         for (let i = 0; i < this.length; i++) {
            var file = new File([this.blobs[i]], "tuwen.jpg", { type: 'image/jpg' });
            let file_url = await this.Upload(file);
            if (file_url) {
               file_urls.push(file_url);
            } else {
               return;
            }
         }

         //提交任务
         let url = file_urls.join(',');
         let model = {
            "success": true,
            "image_task_id": this.task.image_task_id,
            "url": url,
            "error": "",
            "cover": file_urls[0],
            "error_code": 0
         };
         await this.PostTask(model);
      },
      async error(error) {
         await this.PostError(error);
      },
      msg() {
         this.$nextTick(() => {
            const textArea = this.$refs.msg;
            textArea.scrollTop = textArea.scrollHeight;
         });
      }
   },
   methods: {
      //获取任务
      async Gettask() {
         if (this.is_dev) {
            //示例模版
            let info = infos.find(x => x.template_code == this.template_dev);
            if (this.index_dev > 0) {
               info.index = this.index_dev;
            }
            this.infos.push(info);
            this.waitForAllImages('#app').then(() => {
               this.showmsg('图片加载完毕')
               this.Cutimage()
            }).catch((error) => {
               this.showmsg('图片加载失败')
            });
            return;
         }

         //服务器任务
         await axios.get(`${process.env.VUE_APP_TASK_API}/ai_task/get_image_task`).then(async res => {
            //固定数据测试
            // res.data = { "code": 200, "data": { "image_task_id": 7539, "id_template": "T001", "resources": [{ "id": 0, "url": "https://wx001.158.net/5004/files/syo158_main_dev/76/file/1efb38d53d994ddb8fdfd20288ca2b27.jpg" }, { "id": 0, "url": "https://wx001.158.net/5004/files/syo158_main_dev/76/file/1efb38d53d994ddb8fdfd20288ca2b27.jpg" }], "titles": ["杭州思亿欧", "专注网站优化"], "kws": [], "company": "", "company_short": "", "company_en": "", "company_en_short": "", "logo": "", "website": "", "specialty": [], "specialty_short": [] }, "msg": "success" }
            let data = res.data.data;
            if (data == null) {
               this.showmsg('无任务')
               await this.delayAsync(1000 * 10);
               location.reload(true);
               return;
            }
            //解析数据
            let infos = [];
            let resources = data.resources;
            this.task = data;
            this.length = resources.length;
            for (let i = 0; i < this.length; i++) {
               let b = await this.urlToBlob(resources[i].url);
               if (b) {
                  infos.push({
                     template_code: data.id_template,
                     titles: data.titles,
                     specialty_short: data.specialty_short,
                     specialty: data.specialty,
                     company: data.company,
                     image: b,
                     index: i
                  });
               }
            }
            this.infos = infos;
            // console.log(this.infos)
            this.waitForAllImages('#app').then(() => {
               this.showmsg('图片加载完毕')
               this.Cutimage()
            }).catch((error) => {
               this.showmsg('图片加载失败')
            });
         }).catch(async error => {
            this.showmsg('获取任务错误' + error);
            await this.delayAsync(1000 * 10);
            location.reload(true);
         })
      },
      //提交任务
      async PostTask(model) {
         let data = JSON.stringify(model);
         let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.VUE_APP_TASK_API}/ai_task/complete_image`,
            headers: {
               'Content-Type': 'application/json',
            },
            data: data
         };
         await axios.request(config)
            .then(async (res) => {
               this.showmsg('已提交任务')
            }).catch(error => {
               this.showmsg('提交任务报错' + error)
            })
         await this.delayAsync(1000 * 3)
         location.reload(true);//循环触发
      },
      //提交错误
      async PostError(error) {
         let model = {
            "success": false,
            "image_task_id": this.task.image_task_id,
            "url": '',
            "error": error,
            "cover": '',
            "error_code": 0
         };
         await this.PostTask(model);
      },
      //截图
      async Cutimage() {
         let els = document.querySelectorAll(".cutbox");
         if (els.length == 0) {
            return;
         }
         let blobs = [];
         for (let i = 0; i < els.length; i++) {
            let canvas = await html2canvas(els[i], {
               useCORS: true,
               backgroundColor: null,
               // foreignObjectRendering: true
            });
            let blob = await this.canvsToBlob(canvas);
            blobs.push(blob);
         }
         this.blobs = blobs;
      },
      //上传
      async Upload(file) {
         let file_url = "";
         let data = new FormData();
         data.append('project', 'syo158_main');
         data.append('dir', 'tuwen');
         data.append('file', file);
         let upload_url = `${process.env.VUE_APP_UPLOAD_API}?userid=-2`
         let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: upload_url,
            data: data
         };
         await axios.request(config)
            .then(async (response) => {
               if (!response.data.error) {
                  file_url = response.data.file_url;
               } else {
                  this.showmsg('上传错误' + response.data.error);
                  this.error = '上传图片错误';
               }
            }).catch(error => {
               this.showmsg('上传错误' + error);
               this.error = '上传图片错误';
            });
         this.showmsg(file_url);
         return file_url;
      },
      //延时
      async delayAsync(timeout) {
         await new Promise(function (res) {
            setTimeout(() => {
               res();
            }, timeout);
         });
      },
      //图片加载完毕
      //  ImageLoaded(instance) {
      //    console.log(instance.isComplete,111)
      //    if (instance.isComplete) {
      //      this.showmsg('图片加载完毕')
      //      this.Cutimage();
      //    }
      //  },
      //文字显示
      showmsg(msg) {
         console.log(msg);
         this.msg += msg + '\r\n';
      },
      //url转blob
      async urlToBlob(url) {
         const response = await fetch(url);
         if (!response.ok) {
            this.error = `${url}处理失败`;
            return null;
         }
         const blob = await response.blob();
         const blobUrl = URL.createObjectURL(blob);
         this.showmsg('素材图' + blobUrl);
         return blobUrl;
      },
      // 异步截图
      canvsToBlob(canvas) {
         return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
               if (blob) {
                  this.showmsg(URL.createObjectURL(blob));
                  return resolve(blob);
               } else {
                  console.log('截图出错')
                  reject('截图出错')
               }
            }, 'image/jpg');
         })
      },
      //检测图片是否加载完成
      waitForAllImages(selector) {
         return new Promise((resolve, reject) => {
            const container = document.querySelector(selector);
            if (!container) return reject("Container not found.");

            const elements = container.querySelectorAll('*');
            const urls = new Set();

            // 收集所有图片和背景图 URL
            elements.forEach((el) => {
               if (el.tagName === 'IMG' && el.src) {
                  // 检查图片是否已加载，如果已加载直接跳过
                  if (el.complete && el.naturalWidth > 0) {
                     return;
                  }
                  urls.add(el.src);
               }

               const bg = getComputedStyle(el).backgroundImage;
               if (bg && bg !== 'none' && bg.includes('url')) {
                  const matches = bg.match(/url\(["']?([^"')]+)["']?\)/g);
                  if (matches) {
                     matches.forEach((m) => {
                        const url = m.replace(/url\(["']?/, '').replace(/["']?\)$/, '');
                        // 检查背景图片是否已加载
                        const img = new Image();
                        img.src = url;
                        if (img.complete && img.naturalWidth > 0) {
                           return;
                        }
                        urls.add(url);
                     });
                  }
               }
            });

            if (urls.size === 0) {
               resolve(); // 没有图片需要加载，直接返回
               return;
            }

            let loadedCount = 0;
            const total = urls.size;

            // 使用 Promise.all 来并行加载所有图片
            const loadPromises = [...urls].map((url) => {
               return new Promise((resolve, reject) => {
                  const img = new Image();
                  img.onload = img.onerror = () => {
                     loadedCount++;
                     if (loadedCount >= total) {
                        resolve();
                     }
                  };
                  img.src = url;
               });
            });

            // 等待所有图片加载完成
            Promise.all(loadPromises)
               .then(() => resolve())
               .catch(() => reject("Some images failed to load"));
         });
      },
   },
   beforeCreate() {
      // this.waitForAllImages('#app').then(() => {
      //    this.showmsg('图片加载完毕')
      //    this.Cutimage()
      // }).catch((error) => {
      //    this.showmsg('图片加载失败')
      // });
   },
}


</script>
